// const FILENAMES = ['tcc_json.js', 'well_known_cities.js', 'unp_json.js', 'reg_bbox.js', 'static_data_totals.js', 'unp_arr.js']; 

import { get_json_timestamp, is_natural, short_country_name } from '$lib/universal/lib.js';

//import { map } from '$lib/static/map.js';
import { static_data_totals } from '$lib/static/static_data_totals.js';
import { tcc_json } from '$lib/static/tcc_json.js';
import { unp_json } from '$lib/static/unp_json.js';
import { unp_arr } from '$lib/static/unp_arr.js';
import { reg_bbox } from '$lib/static/reg_bbox.js';
import { well_known_cities } from '$lib/static/well_known_cities.js';
import { reg_json } from "$lib/static/reg_json.js";
import { reg_int_ids } from "$lib/static/reg_int_ids.js";

export const js = {
//    map,
    static_data_totals,
    tcc_json,
    unp_json,
    unp_arr,
    reg_bbox,
    well_known_cities,
    reg_json,
    reg_int_ids,
};

export const js_timestamp = {};

for (const key in js) {
    js_timestamp[key] = get_json_timestamp(js[key]);
}


export function get_int_id_by_reg(reg) {
    //console.log(`${reg} -> ${reg_int_ids[reg]}`);
    return reg_int_ids[reg];
}


const int_id_to_reg = new Map();
let cache_timestamp = null;

export function get_reg_by_int_id(int_id) {
    // Rebuild cache if timestamp changed
    if (cache_timestamp !== reg_int_ids.timestamp) {
        int_id_to_reg.clear();
        for (const [key, value] of Object.entries(reg_int_ids)) {
            if (key === "timestamp") continue; // skip the timestamp field
            int_id_to_reg.set(value, key);
        }
        cache_timestamp = reg_int_ids.timestamp;
    }

    return int_id_to_reg.get(int_id);
}


/*
export const js_checksum = {};

await Promise.all([
    checksumJson('tcc_json', tcc_json),
    checksumJson('well_known_cities', well_known_cities),
    checksumJson('unp_json', unp_json),
    checksumJson('reg_bbox', reg_bbox),
    checksumJson('static_data_totals', static_data_totals),
    checksumJson('unp_arr', unp_arr)
]);

async function checksumJson(key, _json) {
    const checksum = await digestAsync(_json, 'SHA-256');
    console.info(`${key} checksum: ${checksum}`);
}
*/

// reg_id might be a string or a number (== id or int_id)
// returns [countryId, countryName, id, regionName]
//      or [id, regionName]
//      or [countryId, countryName]
export function get_region_by_id(reg_id, sourceType = 'reg_json', arr = reg_json, countryId = '', countryName = '', level = 0) {

    if(typeof reg_id !== 'string' && typeof reg_id !== 'number')
        return [];

    //const int_id = is_natural(reg_id) ? +reg_id : undefined;
    if(is_natural(reg_id)) {
        reg_id = get_reg_by_int_id(reg_id);
    }

    for (let i = 0; i < arr.length; i++) {
        if (/*(int_id && arr[i].int_id === int_id) ||*/ arr[i].id === reg_id) {
            const id = arr[i].id;
            let regionName = arr[i].name;

                    // Remove most toxic region name parts (that's for display)
            if(regionName === 'string') {
                regionName = regionName.replace(/Autonomous Okrug/i, "AO")
                            .replace(/\s+Republic$/i, "")
                            .replace(/^(Republic of)\s+/i, "");
            }

            if(id !== 'CRIMEA' && !id?.startsWith('EH') && countryName) {
                if(countryId === id && countryName === arr[i].name) {
                    if(unp_json[countryId]?.dependent && ['AU', 'CN', 'DK', 'FI', 'NL', 'NZ', 'GB', 'FR', 'US'].includes(unp_json[countryId].dependent)) {
                        return [unp_json[countryId].dependent, short_country_name(unp_json[unp_json[countryId].dependent].name), id, regionName];
                    } else {
                        return [id, regionName, '', ''];
                    }
                }
                return [countryId, countryName, id, regionName];
            } else {
                if(arr[i]?.un && arr[i].un !== 'ZZ' && id !== 'TW' && id !== arr[i].un) {
                    if(id.startsWith('X')) {
                        return [id, regionName];
                    } else if (id.startsWith('EH')) {
                        return ['EH', regionName];
                    } else {
                        return [arr[i].un, short_country_name(unp_json[arr[i].un].name), id, regionName];
                    }
                }

                return [id, regionName];
            }
        }

        if (arr[i].db) {
            // level == 0 is for macroregs, and we don't whan mixin them into the result
            const val = get_region_by_id(reg_id, sourceType, arr[i].db, level ? arr[i].id : '', level ? short_country_name(arr[i].name) : '', level + 1);
            if(Array.isArray(val) && val.length > 0) {
                return val;
            }
        }
    }

    // Not found in reg_json, retry with tcc_json
    if(level === 0 && sourceType === 'reg_json') {
        return get_region_by_id(reg_id, 'tcc_json', tcc_json);
    }
    return [];
}
